import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  getEffectiveMax() {
    const values = this.getCurrentValues?.();

    if (!values) return null;

    const { max } = values;

    return max;
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs || {};
    const values = this.getCurrentValues?.();

    if (!values) return;

    const { min, value } = values;
    const effectiveMax = this.getEffectiveMax();

    if (minusButton) {
      minusButton.disabled = value <= min;
    }

    if (plusButton) {
      plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
    }
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}